"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateScheduledReportSchema = exports.createScheduledReportSchema = exports.reportDowSchema = exports.reportDows = exports.reportCadenceSchema = exports.reportCadences = exports.ReportTypeLabels = exports.reportTypeSchema = exports.reportTypes = void 0;
const zod_1 = require("zod");
// ─── Report types ─────────────────────────────────────────────────────────
// Each value here MUST have a renderer registered in apps/api/src/email/
// report-renderers.ts. The renderer is responsible for resolving the date
// window (anchored on the run's "today" in clinic-local tz), producing an
// HTML email body, and optionally a CSV attachment.
exports.reportTypes = [
    'DAILY_ATTENDANCE_SHEET',
    'DAILY_HOUSING_AVAILABILITY',
    'WEEKLY_DISCHARGES',
    'WEEKLY_INTAKES',
    'WEEKLY_UTILIZATION',
    'WEEKLY_CASE_MANAGER_COMPLIANCE',
];
exports.reportTypeSchema = zod_1.z.enum(exports.reportTypes);
exports.ReportTypeLabels = {
    DAILY_ATTENDANCE_SHEET: 'Daily Attendance Sheet',
    DAILY_HOUSING_AVAILABILITY: 'Daily Housing Availability (bed counts)',
    WEEKLY_DISCHARGES: 'Weekly Discharges',
    WEEKLY_INTAKES: 'Weekly Intakes',
    WEEKLY_UTILIZATION: 'Weekly Resource Utilization',
    WEEKLY_CASE_MANAGER_COMPLIANCE: 'Weekly Case-Manager Compliance',
};
// ─── Cadence ──────────────────────────────────────────────────────────────
// Kept deliberately small. The runner ticks every 5 minutes and decides
// whether to fire based on (cadence, hourLocal, minuteLocal, dayOfWeek).
// We don't expose raw cron strings: operators tend to get them wrong, and
// management almost always wants "every weekday at 7am" or "Monday at 8am".
exports.reportCadences = ['DAILY', 'WEEKLY', 'WEEKDAYS'];
exports.reportCadenceSchema = zod_1.z.enum(exports.reportCadences);
exports.reportDows = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
exports.reportDowSchema = zod_1.z.enum(exports.reportDows);
// ─── Schedule create / update payload ─────────────────────────────────────
// Recipient list is a comma- or newline-separated string of email addresses.
// We validate one-per-line on write and stash as a normalized array.
const emailListSchema = zod_1.z
    .string()
    .min(1, 'At least one recipient is required')
    .refine((s) => s
    .split(/[,\n]/)
    .map((x) => x.trim())
    .filter(Boolean)
    .every((x) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(x)), 'One or more email addresses are invalid');
exports.createScheduledReportSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(120),
    reportType: exports.reportTypeSchema,
    cadence: exports.reportCadenceSchema,
    // Local clock anchor (clinic timezone). 24-hour. 7am = hourLocal=7, minuteLocal=0.
    hourLocal: zod_1.z.number().int().min(0).max(23).default(7),
    minuteLocal: zod_1.z.number().int().min(0).max(59).default(0),
    // For WEEKLY cadence only — the day the report sends.
    dayOfWeek: exports.reportDowSchema.nullable().default(null),
    recipients: emailListSchema,
    enabled: zod_1.z.boolean().default(true),
    // Optional CSV attachment toggle. HTML body is always sent; CSV is opt-out
    // for ops who just want a quick eyeball.
    attachCsv: zod_1.z.boolean().default(true),
});
exports.updateScheduledReportSchema = exports.createScheduledReportSchema.partial();
//# sourceMappingURL=scheduled-report.js.map